/** Shaders GLSL ES 3.0 (WebGL2). */

export const VERT = `#version 300 es
in vec2 a_pos;
out vec2 v_uv;
void main() {
  // a_pos en [-1..1] cubre toda la pantalla
  v_uv = a_pos * 0.5 + 0.5;
  v_uv.y = 1.0 - v_uv.y;   // <video> viene con Y invertida
  gl_Position = vec4(a_pos, 0.0, 1.0);
}
`;

/**
 * Aplica en orden: exposición → temperatura → contraste → saturación → LUT.
 * Las operaciones aritméticas son las mismas que el render server-side
 * (eq=brightness=...:contrast=...:saturation=..., lut3d=...), por lo que el
 * preview es fiel al export salvo precisión float (8-bit vs 8-bit es 1:1).
 */
export const FRAG = `#version 300 es
precision highp float;
precision highp sampler3D;

uniform sampler2D u_video;
uniform sampler3D u_lut;
uniform bool      u_useLut;
uniform float     u_lutIntensity;

uniform float u_exposure;      // -2..+2 stops
uniform float u_contrast;      // 0..2 (1 = neutral)
uniform float u_saturation;    // 0..3 (1 = neutral)
uniform float u_temperature;   // -1..+1 (0 = neutral)

in vec2 v_uv;
out vec4 fragColor;

void main() {
  vec3 c = texture(u_video, v_uv).rgb;

  // Exposure (multiplicativo)
  c *= pow(2.0, u_exposure);

  // Temperature: shift R y B en sentidos opuestos (mismo coef que renderer.py)
  c.r *= 1.0 + u_temperature * 0.15;
  c.b *= 1.0 - u_temperature * 0.15;

  // Contraste alrededor de 0.5
  c = (c - 0.5) * u_contrast + 0.5;

  // Saturación (BT.601 luma)
  float l = dot(c, vec3(0.299, 0.587, 0.114));
  c = mix(vec3(l), c, u_saturation);

  c = clamp(c, 0.0, 1.0);

  if (u_useLut) {
    vec3 lc = texture(u_lut, c).rgb;
    c = mix(c, lc, u_lutIntensity);
  }

  fragColor = vec4(c, 1.0);
}
`;
